/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



app.controller('EventCtrl', ['$scope', '$http', 'statisticsService', "$rootScope", 'MainService', 'NetworkService', 'Notification', 'IntentService', function ($scope, $http, statisticsService, $rootScope, MainService, NetworkService, Notification, IntentService) {

        $scope.people = [];
        $scope.eventId = EventId;
        $scope.event = EventDetails

        MainService.setEventData($scope.event)
        $scope.activeAddPositionToSchicht = -1
        $scope.publishState = ($scope.event.veranstaltung_freigegeben == 1)
        $scope.movingPerson = false;
        $scope.inifiniteEvent = false

        $rootScope.$on("repaint", function () {
            $scope.repaintCalendar()
        })

        NetworkService.getMitarbeiterDetails(User, function (data) {
            $rootScope.$emit("setNavName", data);
        })


        NetworkService.getPermissionForEvent($scope.eventId, function (data) {
            $scope.secLevel = data.level
        })

        $scope.error = function (msg) {
            Notification.error(msg);
        };

        $scope.success = function (msg) {
            Notification.success(msg);
        };

        $scope.openShiftCalendar = function ()
        {
            window.location.replace("./Schichtmanager.php?eventid=" + $scope.eventId);
        }

        $scope.addMovingPerson = function (schicht)
        {
            if ($scope.movingPerson)
            {
                if (schicht.menge == null)
                {

                } else
                {
                    var mitarbeiter = schicht.mitarbeiter;
                    var mitarbeiterEmails = Object.keys(mitarbeiter)
                    var count = mitarbeiterEmails.length
                    if (count >= schicht.menge && (schicht.menge != -1))
                    {
                        $scope.error("Voll")
                    } else
                    {
                        var movingEmail = $scope.movingPerson.mitarbeiter.email

                        if (mitarbeiterEmails.indexOf(movingEmail) == -1)
                        {

                            $("body").css("cursor", "default")
                            var move = {from: $scope.movingPerson,
                                to: schicht,
                                event_id: $scope.event.veranstaltung_id}
                            MainService.setDialogData("dialog_moveUserCtrl", move)
                            $scope.movingPerson = false;
                            $("#dialog_moveUser").modal("open")()
                        } else
                        {
                            $scope.error("User ist schon in dieser Position")
                        }
                    }
                }
            }
        }
        $scope.movePerson = function (event, schichtObj, email)
        {
            event.preventDefault()
            event.stopPropagation()
            var el = $(event.currentTarget).parent().parent()
            //el.css("position", "absolute")
            var width = el.width()
            // el.css("width", width+"px")
            $("body").css("cursor", "move")

            var mitarbeiterSchicht = schichtObj.mitarbeiter[email]
            $scope.movingPerson = {
                schicht_id: schichtObj.schicht_id,
                position_id: schichtObj.posId,
                mitarbeiter: mitarbeiterSchicht
            }

            $scope.movePersonHandler = $(document).on("mousemove", function (e) {
                /*  e.preventDefault()
                 var x = e.pageX;
                 var x = x-350
                 var y = e.pageY
                 var y = y-300
                 el.css("left", x+"px")
                 el.css("top", y+"px")*/
            })

        }
        $scope.hasSecLevel = function (minLevel)
        {
            return minLevel >= $scope.secLevel;
        }
        $(document).ready(function () {
            $('#addSchichtStart').bootstrapMaterialDatePicker(
                    {format: 'YYYY-MM-DD HH:mm',
                        currentDate: $scope.event.start,
                        shortTime: false}
            );
            $('#addSchichtEnde').bootstrapMaterialDatePicker(
                    {format: 'YYYY-MM-DD HH:mm',
                        currentDate: $scope.event.start,
                        shortTime: false}
            );
        }
        )
        $scope.addPositionToSchicht = function (schicht_id, position_di)
        {
            $scope.modal1_schicht_id = schicht_id;
            $scope.modal1_position_id = position_di;
            $('#modal1').modal("open")();
            /*
             $("#addPositionToSchichtOverlay").attr("data-schichtId", id)
             $("#addPositionToSchichtOverlay").fadeIn();*/

        }


        $rootScope.$on("statisticChanged", function () {
            $scope.mitarbeiter_fix = statisticsService.getFix()
            $scope.mitarbeiter_free = statisticsService.getFree()
            $scope.mitarbeiter_reserved = statisticsService.getReserved()
            $scope.mitarbeiter_count = statisticsService.getCount()

            $scope.chartData = [
                {
                    key: "Eingetragen",
                    y: $scope.mitarbeiter_fix
                },
                {
                    key: "Frei",
                    y: $scope.mitarbeiter_free
                },
                {
                    key: "Reserviert",
                    y: $scope.mitarbeiter_reserved
                }
            ];
            $scope.options = {
                chart: {
                    type: 'pieChart',
                    height: 350,
                    color: ['#F44336', '#76FF03', '#FFF9C4'],
                    x: function (d) {
                        return d.key;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    showLabels: true,
                    duration: 500,
                    labelThreshold: 0.01,
                    labelSunbeamLayout: true,
                    legend: {
                        margin: {
                            top: 5,
                            right: 35,
                            bottom: 5,
                            left: 0
                        }
                    }
                }
            };

        })


        $scope.addSchichtToEvent = function ()
        {
            data = {
                name: $scope.schichtName,
                start: $scope.schichtStart,
                ende: $scope.schichtEnde,
                event: $scope.eventId

            }
            NetworkService.addSchichtToEvent(data, function (data) {
                $rootScope.$emit("repaint");
            })
        }

        $scope.openShowChart = function ()
        {
            //window.getPDFList($scope.eventId)
            MainService.setDialogData('dialog_printPDFCtrl', {event_id: $scope.eventId})
            $("#dialog_printPDF").modal("open")()
        }
        $scope.changeView = function (type)
        {
            if (type == 0)
            {
                $rootScope.$emit("changeView")
            }
        }

        $scope.openEditMode = function ()
        {
            var picIsThere = false
            try
            {
                var img = $("#fotoCtrlImg")[0]
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                picIsThere = true
            } catch (e)
            {

            }
            if (picIsThere)
            {
                MainService.setProfilePic(dataURL);
                $rootScope.$emit("setImage");
            }

            $rootScope.$emit("openEditMode")
        }

        $scope.openAddPositionDialog = function ()
        {
            $('#modal4').modal("open")();
        }
        $scope.openSchichtAddDialog = function ()
        {
            $('#modal2').modal("open")();
        }


        $scope.data = {}
        fields = {}
        fields["command"] = "getSchichten"
        fields["event_id"] = EventId





        $scope.addPositionToSchichtButton = function (event)
        {
            schicht_id = $scope.modal1_schicht_id
            position_id = $scope.modal1_position_id

            //schicht = $("#addPositionToSchichtOverlay").attr("data-schichtId")
            //position = $("#addPositionToSchichtSelect").val()
            //position = $("#addPositionToSchichtSelect").find(":selected").attr("positionId")
            count = $("input[name=addPositionToSchichtCount]").val()
            if ($scope.inifiniteEvent)
            {
                count = -1
            }
            $('#modal1').modal("close");
            NetworkService.addPositionToSchicht(schicht_id, position_id, count, function () {
                $rootScope.$emit("repaint")
            })


        }


        $scope.printDate = function (date) {
            dateObj = new mDate(date);

            return dateObj.getDate();
        }

        $scope.deleteSchicht = function (schichtId)
        {
            fields["command"] = "deleteSchicht"
            fields["schicht_id"] = schichtId;

            var req = {
                method: 'POST',
                url: "Api/hosiapi.php",
                data: $.param(fields),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            }
            $http(req).then(function (data) {
                //$scope.data = data.data["schichten"];
            }, "json");
        }

        $scope.printTime = function (date) {
            dateObj = new mDate(date);
            return dateObj.getTime();
        }

        var req = {
            method: 'POST',
            url: "Api/hosiapi.php",
            data: $.param(fields),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }

        $http(req).then(function (data) {
            $scope.data = data.data["schichten"];
        }, "json");

        var req2 = {
            method: 'POST',
            url: "Api/hosiapi.php",
            data: $.param({"command": "getEvents"}),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }

        $http(req2).then(function (data) {
            $scope.veranstaltungen = data.data;
        }, "json");

        var req3 = {
            method: 'POST',
            url: "Api/hosiapi.php",
            data: $.param({"command": "getPositionen"}),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }

        $http(req3).then(function (data) {

            //$scope.positionen = data.data;
        }, "json");

        fields4 = {command: "getMitarbeiterNames"}
        var req4 = {
            method: 'POST',
            url: "Api/hosiapi.php",
            data: $.param(fields4),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }

        $http(req4).then(function (data) {
            $scope.mitarbeiter = data.data
            //console.log(data.data)
        }, "json");


    }]);

